// @flow

// Effect Managers
import { take, put, select, fork, call, cancel } from 'redux-saga/effects'

// Sagas
import { centerMapToDefaultLocation } from './watchCenterMapDefault'

// Controllers
import assetsCtrl from 'fc-ctrl-assets'

// Selectors
import { getFarmBboxById$ } from 'hfty-map'

// Actions
import { setUserStateBbox } from 'hfty-map/src/actions'

// Constants
import { CENTER_MAP_TO_FARM } from '../constants'

export default function *watchCenterMapToFarm (): Generator<*, *, *> {
  while (true) {
    const { seasonId, farmId } = yield take(CENTER_MAP_TO_FARM)

    yield fork(handleFarmCentering, { seasonId, farmId })
  }
}

export function *handleFarmCentering ({ seasonId, farmId }: { seasonId: number, farmId: number }): Generator<*, *, *> {
  let farmBbox = yield select(getFarmBboxById$({ seasonId, farmId }))

  if (farmBbox.length) {
    yield fork(centerMapToFarm, farmBbox)
  } else {
    const centerToDefault = yield fork(centerMapToDefaultLocation)

    yield fork(watchReceiveAssets, { seasonId, farmId, centerToDefault })
  }
}

function *centerMapToFarm (farmBbox: Array): Generator<*, *, *> {
  const map = window._m

  yield put(setUserStateBbox(farmBbox))

  if (map) {
    map.fitBounds(farmBbox)
  }
}

function *watchReceiveAssets (
  {
    seasonId,
    farmId,
    centerToDefault,
    }: {
    seasonId: number,
    farmId: number,
    centerToDefault: Object,
  }): Generator<*, *, *> {
  let farmBbox = []

  while (!farmBbox.length) {
    yield take(assetsCtrl.actionTypes.receive())

    farmBbox = yield select(getFarmBboxById$({ seasonId, farmId }))

    if (farmBbox.length) {
      yield cancel(centerToDefault)
      yield call(centerMapToFarm, farmBbox)
    }
  }
}
